export default __webpack_public_path__ + "static/media/target-icon.12570578.png";